export default __webpack_public_path__ + "static/media/install.4b95853b.svg";